export default __webpack_public_path__ + "static/media/showers.c686ad49.mp4";